import base from './base';

const userAPI = dispatch => {
  return {
    async onAddToWatchlist(data) {
      return base.privateApi(dispatch, {
        path: `/user/watchlist/add`,
        method: 'post',
        data,
      });
    },

    async onRemoveWatchlist(data) {
      return base.privateApi(dispatch, {
        path: `/user/watchlist/remove`,
        method: 'delete',
        data,
      });
    },

    async filterWatchlist(data) {
      const response = await base.privateApi(dispatch, {
        path: `/user/watchlist`,
        method: 'post',
        data
      });
      return response;
    },

    async getList(page = 1, status, email) {
      const queries = [`page=${page}`];
      if (status) {
        queries.push(`status=${status}`);
      }
      if (email) {
        queries.push(`email=${email}`)
      }
      const query = queries.join('&');
      const response = await base.privateApi(dispatch, {
        path: `/users?${query}`,
        method: 'get',
      });
      return response;
    },

    async getListByRole(page = 1, role) {
      const queries = [`page=${page}`];
      if (role) {
        queries.push(`role=${role}`);
      }
      const query = queries.join('&');
      const response = await base.privateApi(dispatch, {
        path: `/users?${query}`,
        method: 'get',
      });
      return response;
    },

    async getUserInfo() {
      const response = await base.privateApi(dispatch, {
        path: `/user/info`,
        method: 'get',
      });
      return response;
    },

    async getUserDiscount(userId) {
      const response = await base.privateApi(dispatch, {
        path: `/user-discounts?userId=${userId}`,
        method: 'get',
      });
      return response;
    },

    async createUserDiscount(data) {
      return base.privateApi(dispatch, {
        path: `/user-discounts`,
        method: 'post',
        data,
      });
    },

    async updateUserDiscount(discountId, data) {
      return base.privateApi(dispatch, {
        path: `/user-discounts/${discountId}`,
        method: 'put',
        data,
      });
    },

    async updateUserAutoPayment(data) {
      return base.privateApi(dispatch, {
        path: `/users/self/auto_payment`,
        method: 'put',
        data,
      });
    },

    async revokePayoneerToken() {
      const response = await base.privateApi(dispatch, {
        path: `/users/payoneer-revoke`,
        method: 'post',
      });
      return response;
    },

    async updateUserReferral(data) {
      return base.privateApi(dispatch, {
        path: `/users/self`,
        method: 'put',
        data,
      });
    },
    async getOne(accountId) {
      const response = await base.privateApi(dispatch, {
        path: `/users/${accountId}`,
        method: 'get',
      });
      return response;
    },

    async createUser(data) {
      return base.privateApi(dispatch, {
        path: '/users',
        method: 'post',
        data,
      });
    },

    async updateUser(userId, data) {
      return base.privateApi(dispatch, {
        path: `/users/${userId}`,
        method: 'put',
        data,
      });
    },

    async updateInvoiceInfo(data) {
      return base.privateApi(dispatch, {
        path: '/users/self',
        method: 'put',
        data,
      });
    },

    async updateUserPassword(data) {
      return base.privateApi(dispatch, {
        path: `/user/password`,
        method: 'put',
        data,
      });
    },
  };
};

export default userAPI;
